import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import {App} from "./App";
import {ConfigProvider} from "antd";

const elem = document.getElementById("root")!;
const app = (
    <StrictMode>
        <ConfigProvider>
            <App/>
        </ConfigProvider>
    </StrictMode>
);

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
(import.meta.hot.data.root ??= createRoot(elem)).render(app);
